import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mstype:false,
    titName:{}
  },
  getters: {
    formattedmstype(state) {
      return state.mstype;
    },
    formattedtitName(state) {
      return state.titName;
    }
  },
  mutations: {
    setMstype(state, newMstype) {
      state.mstype = newMstype;
    },
    setTitName(state, newTitName) {
      state.titName = newTitName;
    }
  },
  actions: {
    updateMessage({ commit }, newMstype) {
      commit('setMstype', newMstype);
    },
    updateTitName({ commit }, newTitName) {
      commit('setTitName', newTitName);
    }
  },
  modules: {},
});
